const BrandMark = ({ size = 36 }) => (
  <svg
    className="brand-mark"
    width={size}
    height={size}
    viewBox="0 0 64 64"
    role="img"
    aria-label="Tech Training"
    data-testid="brand-mark"
  >
    <rect width="64" height="64" rx="16" fill="none" stroke="rgba(255,255,255,.42)" strokeWidth="2" />
    <path d="M17 15h10L19 49H9l8-34Zm21 0h17l-3 10h-7l-6 24H29l6-24H18l3-10h17Z" fill="#c9ff35" />
  </svg>
);

export default BrandMark;
